import React from 'react';

export default function Loader() {
  return <span className="loader"></span>;
}
export function ButtonLoader() {
  return (
    <div className="d-flex justify-content-center" style={{ margin: 'auto' }}>
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
